import Swiper from 'swiper/core';
import loaded from '@/scripts/helpers/loaded';

loaded(() => {
    document.querySelectorAll('.js--hover--play--video').forEach(function(element) {
        element.addEventListener('mouseenter', function() {
            var id = 'video__' + this.getAttribute('data-id'),
                vid = document.getElementById(id);
            if (vid) {
                vid.play();
            }
        });
        
        element.addEventListener('mouseleave', function() {
            var id = 'video__' + this.getAttribute('data-id'),
                vid = document.getElementById(id);
            if (vid) {
                vid.pause();
            }
        });
    });
});

loaded(() =>{
    const sliders = Array.from(document.querySelectorAll('.slider--js__hero'));
    if (!sliders) {
        return;
    }

    if (!sliders?.length) {
        return;
    }

    sliders.forEach((slider) => {
        const speed = slider.dataset.autoplaySpeed;

        new Swiper(slider, {
            slidesPerView: "auto",
            effect: "fade",
            allowTouchMove: true,
            freeMode: false,
            loop: false,
            pagination: false,
            autoplay: {
                delay: speed ? parseInt(speed) : 4500,
                disableOnInteraction: false
            }
        })

    });
});
